import { getVipTypeByUser } from "@/constants/vip";
import useRequest from "@/utils/useReq";
import { useCallback, useContext, useEffect, useState } from "react";
import { getVipGoods } from "../../../services";
import { VipDialogContext } from "../shared/configContext";
import { isExpVip } from "../shared/utils";
import { VipTab } from "../shared/vipTab";
import CompanyTab from "./companyTab";
import styles from "./index.module.less";
import PersonalTab from "./personalTab";
import SubscribeMngTab from "./subscribeMngTab";

/**
 * @param {{
 *  defaultVipType: "company"|"personal",
 *  typeChange: (type: "company"|"personal")=>void
 *  defaultSelectPlusSku: string
 *  hideSingleCategory: boolean
 *  selectedPkg: string
 *  versionTab: number|string
 *  user: IUser
 *  onOrderDone: (order)=>void
 *  onCancel: ()=>void
 *  onUnSubscribe: ()=>void
 *  onTransfer: ()=>void
 * } & import("react").HTMLAttributes} props
 * @returns
 */
export default function VipDetail({
  user,
  defaultVipType = "personal",
  selectedPkg,
  hideSingleCategory,
  defaultSelectPlusSku,
  versionTab,
  onOrderDone,
  typeChange,
  onUnSubscribe,
  onCancel,
  onTransfer,
  ...rest
} = {}) {
  const vipGoods = useRequest(getVipGoods);
  const { config, rightData } = useContext(VipDialogContext);
  const [step, setStep] = useState(
    rightData?.subscription?.length ? "subscribe" : "personalVip"
  );

  const [currentVip, setCurrentVip] = useState(defaultVipType);

  useEffect(() => {
    typeChange && typeChange(currentVip);
  }, [currentVip, typeChange]);

  useEffect(() => {
    if (rightData?.subscription?.length) {
      setStep("subscribe");
    }
  }, [rightData]);

  const [disabled, setDisabled] = useState(false);
  const onDisableChange = useCallback((state) => {
    setDisabled(state);
  }, []);

  if (!rightData || vipGoods.loading || !config) {
    // 占位元素
    return <div className={styles.detailsBlock}></div>;
  }

  const currentUserVipType = getVipTypeByUser(user);

  return (
    <div {...rest} className={styles.details}>
      {currentUserVipType !== "company" && (
        <VipTab
          conf={config}
          currentVip={currentVip}
          setCurrentVip={setCurrentVip}
          disabled={disabled}
        />
      )}

      <div className={styles.container}>
        {currentVip === "personal" && currentUserVipType !== "company" ? (
          step === "subscribe" ? (
            <SubscribeMngTab
              onMore={() => setStep("personalVip")}
              onUnSubscribe={onUnSubscribe}
              onCancel={onCancel}
            />
          ) : (
            <PersonalTab
              goods={vipGoods.data.list}
              onOrderDone={onOrderDone}
              rightData={rightData}
              onUnSubscribe={onUnSubscribe}
              onCancel={onCancel}
              onDisableChange={onDisableChange}
              hideSingleCategory={hideSingleCategory}
              defaultSelectedPkg={selectedPkg}
              defaultSelectPlusSku={defaultSelectPlusSku}
              versionTab={versionTab}
              onTransfer={onTransfer}
            />
          )
        ) : (
          <CompanyTab
            isUpgrade={currentUserVipType === "personal"}
            isExpVip={rightData.vips?.length && isExpVip(user)}
            goods={vipGoods.data.list}
            onOrderDone={onOrderDone}
            rightData={rightData}
            onDisableChange={onDisableChange}
            defaultSelectedPkg={selectedPkg}
            defaultSelectPlusSku={defaultSelectPlusSku}
            versionTab={versionTab}
            onTransfer={onTransfer}
          />
        )}
      </div>
    </div>
  );
}
